import { render, staticRenderFns } from "./TopbarDropdown.vue?vue&type=template&id=84bbaca4&scoped=true"
import script from "./TopbarDropdown.vue?vue&type=script&lang=ts"
export * from "./TopbarDropdown.vue?vue&type=script&lang=ts"
import style0 from "./TopbarDropdown.vue?vue&type=style&index=0&id=84bbaca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bbaca4",
  null
  
)

export default component.exports